import { useQuery } from '@tanstack/react-query';
import { useRequest } from '~/lib/useRequest';
import { config } from '~/config';
import { hasKey } from '~/utils';
import { GradePointMapping } from '~/types/gradeConversion';
import { ListGradePointMappingsResponse, GradePointMappingResource } from '@ab/ams-school-api/types/private/v1';

export function useGradePointMappings() {
  const request = useRequest();

  const { isLoading, error, data, isError } = useQuery({
    queryKey: ['gradePointMappings'],
    queryFn: async () => {
      const response = await request<ListGradePointMappingsResponse>(
        `${config.apiHost}/private/v1/grade_point_mappings?page[number]=1&page[size]=100`,
        {
          method: 'GET',
          isExpectedResponse,
        }
      );

      const mappings: GradePointMapping[] = response.data.map((item: GradePointMappingResource) => ({
        id: item.id,
        letterGrade: item.attributes.letterGrade,
        rangeLow: item.attributes.rangeLow,
        rangeHigh: item.attributes.rangeHigh,
      }));

      return mappings;
    },
  });

  return {
    isLoadingGradePointMappings: isLoading,
    gradePointMappingsError: error,
    gradePointMappings: data ?? [],
    isGradePointMappingsError: isError,
  };
}

function isExpectedResponse(res: unknown): res is ListGradePointMappingsResponse {
  return Boolean(res && typeof res === 'object' && hasKey('data', res));
}
